import { Flex, Stack } from '@chakra-ui/react';
import { antlerStyle } from '@constants/styles';
import DefaultLayout from '../DefaultLayout';

function WizardLayout({ children, maxWidth = '1000px' }: { children: React.ReactNode; maxWidth?: string }) {
  return (
    <DefaultLayout showFooter={false}>
      <Flex
        width="100%"
        maxWidth={maxWidth}
        overflow="hidden"
        alignItems="center"
        mx="auto"
        justifyContent="center"
        px={[6, 10, 10, 36]}
        bg="darkBackground"
        pb={16}
      >
        <Stack
          w="100%"
          maxW="1000px"
          py={[8, 8, 16]}
          minH={antlerStyle.heroHeight}
          mx="auto"
          spacing={[3, 3, 4]}
          alignItems={['stretch', 'stretch', 'center']}
        >
          {children}
        </Stack>
      </Flex>
    </DefaultLayout>
  );
}

export default WizardLayout;
